import capitalAdvertisement from "../public/Advertising/5.jpg"

import reefIcon from "../public/Reef/icon.png"
import reefLogo from "../public/Reef/logo.png"
import reefBackground from "../public/Reef/background.jpg"
import reefPalette from "./palettes/reef"

import paradiseIcon from "../public/Paradise/icon.png"
import paradiseLogo from "../public/Paradise/logo.png"
import paradiseBackground from "../public/Paradise/background.jpg"
import paradisePalette from "./palettes/paradise"

class Brand {
  /**
   * @param {{ id, name, icon, palette, logo, background, advertisement, helpLink }} config
   */
  constructor(config) {
    this.id = config.id
    this.name = config.name
    this.icon = config.icon
    this.palette = config.palette
    this.logo = config.logo
    this.background = config.background
    this.advertisement = config.advertisement
    this.helpLink = config.helpLink
  }
}

// List of implemented brands
const REEF_BRAND = new Brand({
  id: "",
  name: "Reef Pay",
  icon: reefIcon,
  palette: reefPalette,
  logo: reefLogo,
  background: reefBackground,
  advertisement: capitalAdvertisement,
  helpLink: "https://docs.reefpay.net"
})

const PARADISE_BRAND = new Brand({
  id: "paradise_pay",
  name: "Paradise Payments",
  icon: paradiseIcon,
  palette: paradisePalette,
  logo: paradiseLogo,
  background: paradiseBackground,
  helpLink: "https://docs.myparadisepay.com"
})

// Map branding to a desired host location
const HOST_TO_BRAND_MAP = {
  "localhost": REEF_BRAND,
  "portal.sandbox.reefpay.net": REEF_BRAND,
  "portal.dev.reefpay.net": REEF_BRAND,
  "portal.reefpay.net": REEF_BRAND,
  "secure.sandbox.myparadisepay.com": PARADISE_BRAND,
  "secure.dev.myparadisepay.com": PARADISE_BRAND,
  "secure.myparadisepay.com": PARADISE_BRAND
}

// Provide a simple branding service that provides the correct branding resources automatically
export default class BrandingService {
  /**
   * @returns {Brand} The current branding resources for system features & rendering
   */
  static get current() {
    const brand = HOST_TO_BRAND_MAP[window.location.host] || REEF_BRAND
    document.title = brand.name
    var icon = document.querySelector("link[rel='icon']")
    if (icon) icon.href = brand.icon
    return brand
  }
}